// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import { Toaster } from 'react-hot-toast';
import { register } from './serviceWorkerRegistration';
import '@fortawesome/fontawesome-free/css/all.min.css'; 

// Function to get CSRF token from cookies
const getCsrfToken = () => {
  const value = `; ${document.cookie}`;
  const parts = value.split('; csrftoken=');
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

// Set up Axios defaults
axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';
axios.defaults.withCredentials = true;

// Add CSRF token to every request
axios.interceptors.request.use((config) => {
  const token = getCsrfToken();
  if (token && ['post', 'put', 'patch', 'delete'].includes(config.method)) {
    config.headers['X-CSRFToken'] = token;
  }
  return config;
}, (error) => {
  Promise.reject(error);
});
// Check for new version
const checkVersion = async () => {
  try {
    const response = await fetch('/version.json?v=' + Date.now());
    const versionData = await response.json();
    const currentVersion = process.env.REACT_APP_VERSION || '1.0.0';
    if (versionData.version !== currentVersion) {
      alert('A new version of SErraND is available. Please reload the page to update.');
    }
  } catch (err) {
    console.error('Version check failed:', err);
  }
};
checkVersion();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
      <Toaster position="top-right" />
    </HelmetProvider>
  </React.StrictMode>
);

// Register service worker
register({
  onSuccess: () => console.log('Service Worker: Registered'),
  onError: (error) => console.error('Service Worker: Error', error),
});

reportWebVitals();
